/**
 * The bar scrolls away with the page, as it does over a theme with a sticky header. Woood's header is position: fixed
 * instead, so this keeps it, the side menu and the drawer just under the bar until it is gone (`_design.scss`).
 */
export class PrototypeBarOffset {
    public static bind(bar: HTMLElement) {
        let scheduled = false;
        const update = () => {
            scheduled = false;
            document.documentElement.style.setProperty('--prototype-bar-offset', `${Math.max(0, bar.offsetHeight - window.scrollY)}px`);
        };

        window.addEventListener('scroll', () => {
            if (!scheduled) {
                scheduled = true;
                requestAnimationFrame(update);
            }
        }, { passive: true });
        update();
    }
}
